module.exports = __webpack_public_path__ + "static/media/home-bg.219c2a2b.jpg";